/* ── Bundle free-gift sync ───────────────────────────────────────────────────────
   After any cart update:
     • Remove free-gift items whose threshold is no longer met.
     • Add free-gift items when the threshold is newly met.
   On page load: run once to reconcile stale cart state (skipped when nothing to do).
   On any 429: reload the page immediately (cart will be consistent after reload).
*/
// (function () {
//   var _debounceTimer = null;
//   var _syncRunning = false;
//   var CART_SECTIONS = 'el-cart-drawer,el-cart-icon-bubble';

//   /* ── Loading overlay helpers ──────────────────────────────── */
//   function getOrCreateOverlay() {
//     var inner = document.querySelector('#CartDrawer .drawer__inner');
//     if (!inner) return null;
//     var existing = inner.querySelector('.cd-cleanup-overlay');
//     if (existing) return existing;
//     var el = document.createElement('div');
//     el.className = 'cd-cleanup-overlay';
//     el.setAttribute('aria-hidden', 'true');
//     el.innerHTML =
//       '<svg class="cd-cleanup-overlay__spinner" viewBox="25 25 50 50">' +
//       '<circle class="cd-cleanup-overlay__path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/>' +
//       '</svg>';
//     inner.appendChild(el);
//     return el;
//   }
//   function showLoading() {
//     /* Skip when the drawer is closed — avoids unnecessary DOM work during
//        background syncs (page load, bfcache restore, etc.) */
//     var drawer = document.querySelector('cart-drawer');
//     if (!drawer || !drawer.classList.contains('active')) return;
//     var el = getOrCreateOverlay();
//     if (el) el.classList.add('is-visible');
//   }
//   function hideLoading() {
//     var el = document.querySelector('#CartDrawer .drawer__inner .cd-cleanup-overlay');
//     if (el) el.classList.remove('is-visible');
//   }

//   /* ── 429 / network-safe fetch ─────────────────────────────── */
//   async function cartFetch(url, opts) {
//     let r;
//     try {
//       r = await fetch(url, opts);
//     } catch (_) {
//       window.location.reload();
//       return new Promise(function () { });
//     }
//     if (r.status === 429) {
//       window.location.reload();
//       return new Promise(function () { });
//     }
//     return r.json();
//   }

//   /* ── Apply section HTML to the page ─────────────────────────
//      Shared by refreshCartUI and piggy-backed section responses. */
//   function applyCartSections(sections) {
//     var drawerHtml = sections['el-cart-drawer'];
//     if (drawerHtml) {
//       var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
//       var newInner = doc.querySelector('#CartDrawer .drawer__inner');
//       var currInner = document.querySelector('#CartDrawer .drawer__inner');
//       if (newInner && currInner) currInner.innerHTML = newInner.innerHTML;

//       var newEl = doc.querySelector('cart-drawer');
//       var currEl = document.querySelector('cart-drawer');
//       if (newEl && currEl) currEl.classList.toggle('is-empty', newEl.classList.contains('is-empty'));
//     }

//     var bubbleHtml = sections['el-cart-icon-bubble'];
//     if (bubbleHtml) {
//       var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
//       var newBubble = bubbleDoc.querySelector('.shopify-section');
//       var currBubble = document.getElementById('el-cart-icon-bubble');
//       if (newBubble && currBubble) currBubble.innerHTML = newBubble.innerHTML;
//     }
//   }

//   /* ── Refresh drawer + icon via fresh SSR fetch ───────────────
//      Always fetches the latest rendered section HTML from Shopify
//      so the Liquid cart context is guaranteed to be current.     */
//   async function refreshCartUI() {
//     var path = window.location.pathname;
//     var url = path + '?sections=' + encodeURIComponent(CART_SECTIONS) + '&sections_url=' + encodeURIComponent(path);
//     var resp = await cartFetch(url);
//     if (resp) applyCartSections(resp);
//   }

//   /* ── Read all bundle free-gift rules from the PDP DOM ───────
//      Iterates every bundle card, not just the selected one.
//      A rule is emitted for each card that has both a non-zero
//      counts value and an additional_free product variant.       */
//   function getBundleRulesFromDOM() {
//     var root = document.querySelector('[data-el-bundles]');
//     if (!root) return [];
//     var productId = String(root.dataset.productId || '');
//     if (!productId) return [];

//     var rules = [];
//     root.querySelectorAll('[data-el-bundle-card]').forEach(function (card) {
//       var slotsEl = card.querySelector('[data-el-bundle-variant-slots]');
//       var threshold = parseInt(slotsEl ? (slotsEl.dataset.elBundleVariantSlots || 0) : 0, 10);
//       var freeInput = card.querySelector('[data-el-free-variant-id]');
//       var freeVid = parseInt(freeInput ? (freeInput.value || 0) : 0, 10);
//       var priceCentsEl = card.querySelector('[data-el-free-price-cents]');
//       var priceOfAdditionCents = parseInt(priceCentsEl ? (priceCentsEl.value || 0) : 0, 10);
//       if (threshold > 0 && freeVid > 0) {
//         rules.push({ productId: productId, threshold: threshold, freeVariantId: freeVid, priceOfAdditionCents: priceOfAdditionCents });
//       }
//     });
//     return rules;
//   }

//   /* ── Read rules from the Liquid-rendered JSON element ────────
//      <script type="application/json" id="el-bundle-rules-data">
//      is injected inside .drawer__inner by el-cart-drawer.liquid.
//      refreshCartUI() replaces that innerHTML, so this element is
//      always current with the latest cart state from Shopify SSR. */
//   function getBundleRulesFromLiquid() {
//     var el = document.getElementById('el-bundle-rules-data');
//     if (!el) return [];
//     try {
//       var rules = JSON.parse(el.textContent || '[]');
//       return Array.isArray(rules) ? rules : [];
//     } catch (_) {
//       return [];
//     }
//   }

//   /* ── Derive rules from free-gift items already in the cart ───
//      Last-resort fallback: if a free gift is already in the cart
//      its properties carry enough info to reconstruct the rule.   */
//   function getBundleRulesFromCart(items) {
//     var seen = {};
//     var rules = [];
//     items.forEach(function (item) {
//       var props = item.properties || {};
//       if (String(props['_bundle_free']) !== '1') return;
//       var mainPid = String(props['_bundle_main_product_id'] || '');
//       var threshold = parseInt(props['_bundle_qty_threshold'] || '0', 10);
//       var freeVid = item.variant_id;
//       if (!mainPid || threshold <= 0 || !freeVid) return;
//       var key = mainPid + ':' + freeVid;
//       if (!seen[key]) {
//         seen[key] = true;
//         var priceOfAdditionCents = parseInt(props['_bundle_price_cents'] || '0', 10);
//         rules.push({ productId: mainPid, threshold: threshold, freeVariantId: freeVid, priceOfAdditionCents: priceOfAdditionCents });
//       }
//     });
//     return rules;
//   }

//   /* ── Resolve rules: DOM → Liquid SSR element → cart items ────
//      1. PDP bundle DOM (most specific — user is on the bundle page)
//      2. Liquid JSON element in cart drawer (works on all pages,
//         reads product metafields server-side for every cart item)
//      3. Cart item properties (works when gift already in cart)   */
//   function getBundleRules(items) {
//     var domRules = getBundleRulesFromDOM();
//     if (domRules.length > 0) return domRules;
//     var liquidRules = getBundleRulesFromLiquid();
//     if (liquidRules.length > 0) return liquidRules;
//     return getBundleRulesFromCart(items);
//   }

//   /* ── Check whether sync is needed ─────────────────────────────
//      Reads the Liquid-rendered data to decide before fetching
//      /cart.js. Returns true if bundle rules or free-gift items
//      exist — meaning there could be something to add or remove.
//      Called before every sync (initial + pub/sub-triggered) so that
//      after a fresh SSR re-render shows nothing to do we skip the
//      /cart.js round-trip entirely.                                 */
//   function needsSync() {
//     /* PDP page with bundle UI — always sync */
//     if (document.querySelector('[data-el-bundles]')) return true;
//     var rulesEl = document.getElementById('el-bundle-rules-data');
//     if (!rulesEl) return false;
//     /* Free-gift items exist in cart — may need cleanup */
//     if (rulesEl.dataset.hasFreeGifts === 'true') return true;
//     /* Liquid rules exist — may need to add free gifts */
//     try {
//       var rules = JSON.parse(rulesEl.textContent || '[]');
//       return Array.isArray(rules) && rules.length > 0;
//     } catch (_) {
//       return false;
//     }
//   }

//   /* ── Main sync: remove excess + add missing free gifts ───────
//      Single cart fetch → compute diffs → batched remove →
//      one add call → one UI update.                              */
//   async function syncFreeGifts() {
//     if (_syncRunning) return;
//     /* Pre-check: if the SSR-rendered state shows no rules and no
//        free-gift items, there is nothing to add or remove — skip
//        the /cart.js fetch entirely.  Works for both initial sync
//        and pub/sub-triggered syncs (drawer HTML is fresh after
//        CartDrawerItems.onCartUpdate re-renders it).               */
//     if (!needsSync()) return;
//     _syncRunning = true;
//     showLoading();

//     try {
//       var cart = await cartFetch('/cart.js');
//       if (!cart) return;
//       var items = cart.items || [];

//       /* 1. Compute removals ───────────────────────────────────── */
//       var qtyByProduct = {};
//       items.forEach(function (item) {
//         var pid = String(item.product_id);
//         qtyByProduct[pid] = (qtyByProduct[pid] || 0) + item.quantity;
//       });

//       var toRemove = [];
//       items.forEach(function (item, idx) {
//         var props = item.properties || {};
//         if (String(props['_bundle_free']) !== '1') return;
//         var mainPid = String(props['_bundle_main_product_id'] || '');
//         var threshold = parseInt(props['_bundle_qty_threshold'] || '0', 10);
//         if (!mainPid) return;
//         var earned = threshold <= 0
//           ? 0
//           : Math.floor((qtyByProduct[mainPid] || 0) / threshold);
//         if (item.quantity > earned) {
//           toRemove.push({ key: item.key, line: idx + 1, quantity: earned });
//         }
//       });

//       /* 2. Compute additions ──────────────────────────────────── */
//       var toAdd = [];
//       var rules = getBundleRules(items);

//       /* Lines being reduced/removed — keyed by 1-based line number,
//          value is the quantity that will remain after the change.    */
//       var removedQty = {};
//       toRemove.forEach(function (r) { removedQty[r.line] = r.quantity; });

//       rules.forEach(function (cfg) {
//         /* Non-free-gift qty of the main product currently in cart */
//         var mainQty = items.reduce(function (sum, item) {
//           if (String(item.product_id) === cfg.productId &&
//             String((item.properties || {})['_bundle_free']) !== '1') {
//             return sum + item.quantity;
//           }
//           return sum;
//         }, 0);

//         var earned = Math.floor(mainQty / cfg.threshold);

//         /* Free-gift qty already in cart for this variant,
//            accounting for lines that are about to be removed */
//         var inCart = items.reduce(function (sum, item, idx) {
//           if (item.variant_id === cfg.freeVariantId &&
//             String((item.properties || {})['_bundle_free']) === '1') {
//             var line = idx + 1;
//             var remaining = (line in removedQty) ? removedQty[line] : item.quantity;
//             return sum + remaining;
//           }
//           return sum;
//         }, 0);

//         var diff = earned - inCart;
//         if (diff > 0) {
//           toAdd.push({
//             id: cfg.freeVariantId,
//             quantity: diff,
//             properties: {
//               '_bundle_free': '1',
//               '_bundle_main_product_id': cfg.productId,
//               '_bundle_qty_threshold': String(cfg.threshold),
//               '_bundle_price_cents': String(cfg.priceOfAdditionCents || 0)
//             }
//           });
//         }
//       });

//       if (!toRemove.length && !toAdd.length) return;

//       /* 3. Execute removals (batched via /cart/update.js) ─────── */
//       var lastResp = null;
//       if (toRemove.length) {
//         var updates = {};
//         toRemove.forEach(function (entry) { updates[entry.key] = entry.quantity; });
//         var body = { updates: updates };
//         /* Piggyback sections on the last call — skip if additions follow */
//         if (!toAdd.length) {
//           body.sections = CART_SECTIONS;
//           body.sections_url = window.location.pathname;
//         }
//         lastResp = await cartFetch('/cart/update.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(body)
//         });
//       }

//       /* 4. Execute additions ──────────────────────────────────── */
//       if (toAdd.length) {
//         lastResp = await cartFetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             items: toAdd,
//             sections: CART_SECTIONS,
//             sections_url: window.location.pathname
//           })
//         });
//       }

//       /* 5. Re-render: prefer piggy-backed sections, fall back to fetch */
//       if (lastResp && lastResp.sections) {
//         applyCartSections(lastResp.sections);
//       } else {
//         await refreshCartUI();
//       }

//     } catch (e) {
//       console.error('[SyncFreeGifts]', e);
//     } finally {
//       _syncRunning = false;
//       hideLoading();
//     }
//   }

//   /* Keep old name working for any external callers */
//   window.cleanupBundleFreeItems = syncFreeGifts;

//   /* Initial sync — run immediately (defer guarantees DOM is parsed).
//      needsSync() inside syncFreeGifts skips the /cart.js fetch when
//      there are no bundle rules or free-gift items to reconcile.     */
//   syncFreeGifts();

//   /* Subscribe to cart updates — wait for DOMContentLoaded because
//      subscribe / PUB_SUB_EVENTS are defined in other deferred scripts
//      that may not have executed yet.                                  */
//   document.addEventListener('DOMContentLoaded', function () {
//     if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
//       subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
//         clearTimeout(_debounceTimer);
//         _debounceTimer = setTimeout(syncFreeGifts, 300);
//       });
//     }
//   });

//   /* ── bfcache restore: refresh cart UI when navigating back from checkout ──
//      When the browser restores the page from back-forward cache (e.persisted),
//      JS does not re-run so the cart icon and drawer are frozen in their
//      pre-checkout state. Re-fetch fresh SSR HTML to restore correct state.   */
//   window.addEventListener('pageshow', function (e) {
//     if (e.persisted) refreshCartUI();
//   });
// })();

/* Upsell carousel — event delegation on document so it works after innerHTML injection */
document.addEventListener('click', function (e) {
  var dot = e.target && e.target.closest ? e.target.closest('.cd-upsell__dot') : null;
  if (!dot) return;
  var wrapper = dot.closest('.cd-upsell');
  if (!wrapper) return;
  var track = wrapper.querySelector('.cd-upsell__track');
  var cards = Array.prototype.slice.call(wrapper.querySelectorAll('.cd-upsell__card'));
  if (!track || cards.length < 2) return;

  var idx = parseInt(dot.dataset.dotIndex, 10);
  if (isNaN(idx)) return;

  var GAP = 12;
  var slideWidth = (cards[0] ? cards[0].offsetWidth : 0) + GAP;
  track.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });

  /* update active dot */
  Array.prototype.slice.call(wrapper.querySelectorAll('.cd-upsell__dot')).forEach(function (d, i) {
    d.classList.toggle('cd-upsell__dot--active', i === idx);
  });
});

/* Drag-to-scroll on desktop — delegated so it works after innerHTML injection.
   Disables CSS snap during drag (prevents sticking), tracks pointer velocity,
   applies momentum on release, then smoothly snaps to the nearest card.      */
(function () {
  var _drag = null;
  var _suppressNextClick = false;

  /* Suppress accidental button clicks that fire after a real drag */
  document.addEventListener('click', function (e) {
    if (!_suppressNextClick) return;
    _suppressNextClick = false;
    if (e.target && e.target.closest && e.target.closest('.cd-upsell__track')) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  document.addEventListener('mousedown', function (e) {
    var track = e.target && e.target.closest ? e.target.closest('.cd-upsell__track') : null;
    if (!track) return;
    if (e.button !== 0) return;
    /* Don't hijack clicks on interactive elements — variant selects, buttons, etc. */
    if (e.target.closest('button, input, select, label, a')) return;

    /* Cancel any running momentum from a previous drag */
    if (_drag) cancelAnimationFrame(_drag.rafId);

    _drag = {
      track:      track,
      startX:     e.clientX,
      scrollLeft: track.scrollLeft,
      lastX:      e.clientX,
      lastTime:   Date.now(),
      velocity:   0,
      moved:      false,
      rafId:      null,
      done:       false
    };

    /* Disable snap so it doesn't fight the pointer while dragging */
    track.style.scrollSnapType = 'none';
    track.style.cursor = 'grabbing';
    track.style.userSelect = 'none';
    e.preventDefault(); /* prevent text selection */
  });

  document.addEventListener('mousemove', function (e) {
    if (!_drag || _drag.done) return;
    var now = Date.now();
    var dt  = now - _drag.lastTime;
    if (dt > 0) {
      _drag.velocity = (e.clientX - _drag.lastX) / dt; /* px/ms */
      _drag.lastX    = e.clientX;
      _drag.lastTime = now;
    }
    if (Math.abs(e.clientX - _drag.startX) > 4) _drag.moved = true;
    _drag.track.scrollLeft = _drag.scrollLeft - (e.clientX - _drag.startX);
  });

  /* Scroll to the card closest to the current scrollLeft, then restore snap */
  function snapToNearest(track) {
    var cards = Array.prototype.slice.call(track.querySelectorAll('.cd-upsell__card'));
    if (!cards.length) { track.style.scrollSnapType = ''; return; }
    var sl = track.scrollLeft;
    var best = cards[0];
    var bestDist = Infinity;
    cards.forEach(function (c) {
      var d = Math.abs(c.offsetLeft - track.offsetLeft - sl);
      if (d < bestDist) { bestDist = d; best = c; }
    });
    var target = best.offsetLeft - track.offsetLeft;
    track.scrollTo({ left: target, behavior: 'smooth' });
    /* Restore snap after the smooth scroll settles */
    var t = setTimeout(function () { track.style.scrollSnapType = ''; }, 400);
    if ('onscrollend' in window) {
      track.addEventListener('scrollend', function () {
        clearTimeout(t);
        track.style.scrollSnapType = '';
      }, { once: true });
    }
  }

  function endDrag() {
    if (!_drag || _drag.done) return;
    _drag.done = true;
    var session = _drag;
    var track   = session.track;
    track.style.cursor     = '';
    track.style.userSelect = '';

    /* Flag so the imminent click event (mousedown→mouseup on same target)
       doesn't fire buttons when the user just finished dragging */
    if (session.moved) _suppressNextClick = true;

    var vel = session.velocity;

    /* No real flick — just snap immediately */
    if (Math.abs(vel) < 0.1) {
      snapToNearest(track);
      _drag = null;
      return;
    }

    /* Apply inertia: decelerate ~5 % per frame at 60 fps, then snap */
    var lastTime = Date.now();
    function step() {
      if (_drag !== session) return; /* a new drag started — stop this one */
      var now = Date.now();
      var dt  = Math.min(now - lastTime, 50); /* cap to avoid huge jumps on tab-switch */
      lastTime = now;
      vel *= Math.pow(0.95, dt / 16);
      if (Math.abs(vel) < 0.05) {
        snapToNearest(track);
        _drag = null;
        return;
      }
      track.scrollLeft -= vel * dt;
      session.rafId = requestAnimationFrame(step);
    }
    session.rafId = requestAnimationFrame(step);
  }

  document.addEventListener('mouseup',    endDrag);
  document.addEventListener('mouseleave', endDrag);
})();

/* Sync dots on scroll — delegated so it works after innerHTML injection */
document.addEventListener('scroll', function (e) {
  var track = e.target && e.target.classList && e.target.classList.contains('cd-upsell__track') ? e.target : null;
  if (!track) return;
  var wrapper = track.closest('.cd-upsell');
  if (!wrapper) return;
  var cards = Array.prototype.slice.call(wrapper.querySelectorAll('.cd-upsell__card'));
  if (cards.length < 2) return;

  var scrollLeft = track.scrollLeft;
  var closest = 0;
  var closestDist = Infinity;
  cards.forEach(function (card, i) {
    var dist = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
    if (dist < closestDist) { closestDist = dist; closest = i; }
  });
  Array.prototype.slice.call(wrapper.querySelectorAll('.cd-upsell__dot')).forEach(function (d, i) {
    d.classList.toggle('cd-upsell__dot--active', i === closest);
  });
}, { passive: true, capture: true });

let cdLocked = false;
let cdStartY = 0;

function cdGetScroller(target) {
  return target.closest && target.closest('#CartDrawer .cart-drawer-items-and-upsell');
}

function cdTouchStart(e) {
  cdStartY = e.touches[0].clientY;
}

function cdTouchMove(e) {
  if (!cdLocked) return;

  const scroller = cdGetScroller(e.target);

  // Outside drawer: never allow body scroll
  if (!scroller) {
    e.preventDefault();
    return;
  }
  if (e.target.closest && e.target.closest('.cd-upsell__track')) return;

  const currentY = e.touches[0].clientY;
  const deltaY = currentY - cdStartY;

  const canScroll = scroller.scrollHeight > scroller.clientHeight;
  const atTop = scroller.scrollTop <= 0;
  const atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;

  // Drawer is short: block body scroll
  if (!canScroll) {
    e.preventDefault();
    return;
  }

  // At drawer edges: block scroll chaining to body
  if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
    e.preventDefault();
  }
}

function cdIsMobileScrollLockNeeded() {
  return window.matchMedia('(max-width: 749px)').matches;
}

function lockBodyScroll() {
  if (cdLocked) return;
  cdLocked = true;

  if (cdIsMobileScrollLockNeeded()) {
    document.addEventListener('touchstart', cdTouchStart, { passive: true });
    document.addEventListener('touchmove', cdTouchMove, { passive: false });
  } else {
    document.documentElement.style.overflow = 'hidden';
  }
}

function unlockBodyScroll() {
  if (!cdLocked) return;
  cdLocked = false;

  if (cdIsMobileScrollLockNeeded()) {
    document.removeEventListener('touchstart', cdTouchStart);
    document.removeEventListener('touchmove', cdTouchMove);
  } else {
    document.documentElement.style.overflow = '';
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#el-cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;

    if (triggeredBy) this.setActiveElement(triggeredBy);

    lockBodyScroll();

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
  }

  close() {
    if (!this.classList.contains('active')) return;

    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    this.addEventListener('transitionend', () => {
      unlockBodyScroll();
    }, { once: true });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    if (typeof parsedState.item_count === 'number') {
      this.classList.toggle('is-empty', parsedState.item_count === 0);
    }
    this.getSectionsToRender().forEach((section => {
      const raw = parsedState.sections && parsedState.sections[section.id];
      if (!raw) return;
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      const selector = section.selector || '.shopify-section';
      const inner = this.getSectionInnerHTML(raw, selector);
      if (inner == null) return;
      sectionElement.innerHTML = inner;
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (typeof window.initCartUpsellCarousel === 'function') {
        window.initCartUpsellCarousel(this);
      }
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'el-cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'el-cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'el-cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'el-cart-icon-bubble',
        section: 'el-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  /**
   * Main cart page uses <cart-items>; the drawer uses <cart-drawer-items>.
   * Refresh from the cart-drawer section so markup and line ids stay correct.
   */
  onCartUpdate() {
    const path = window.location.pathname;
    const url = `${path}?sections=el-cart-drawer&sections_url=${encodeURIComponent(path)}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        const sectionHtml = response && response['el-cart-drawer'];
        if (!sectionHtml) return;
        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const source = doc.querySelector('cart-drawer-items');
        if (!source) return;
        this.innerHTML = source.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ── Cart drawer quantity validation ─────────────────────────────────────
   Intercepts the `change` event (fired on blur AND on Enter) in the capture
   phase — before it reaches CartItems.onChange which sends the backend
   request. If the value is empty or below the minimum:
     • Stop propagation so no backend request is made.
     • Reset the input to the minimum quantity.
     • Show "Quantity cannot be empty." inline and auto-clear after 3 s.
   Also intercepts Enter via keydown to block form submission.             */

function _cdQtyShowError(input, message) {
  var itemEl  = input.closest('[id^="CartDrawer-Item-"]');
  var errorEl = itemEl && itemEl.querySelector('.cart-item__error-text');
  if (!errorEl) return;
  errorEl.textContent = message;
  clearTimeout(errorEl._clearTimer);
  errorEl._clearTimer = setTimeout(function () { errorEl.textContent = ''; }, 3000);
}

function _cdQtyIsInvalid(input) {
  var raw    = input.value.trim();
  var min    = parseInt(input.min || '1', 10);
  var parsed = parseInt(raw, 10);
  return raw === '' || isNaN(parsed) || parsed < min;
}

function _cdQtyRestore(input) {
  var prev = parseInt(input.dataset.prevQty || input.min || '1', 10);
  input.value = prev;
  return prev;
}

/* Stash the current value on focus so we can restore it on invalid input */
document.addEventListener('focusin', function (e) {
  var input = e.target;
  if (!input.classList || !input.classList.contains('quantity__input')) return;
  if (!input.closest('#CartDrawer')) return;
  input.dataset.prevQty = input.value;
}, true);

/* Validate on change (covers blur and programmatic changes) */
document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input.classList || !input.classList.contains('quantity__input')) return;
  if (!input.closest('#CartDrawer')) return;

  if (_cdQtyIsInvalid(input)) {
    e.stopImmediatePropagation(); /* prevent backend request */
    _cdQtyRestore(input);
    _cdQtyShowError(input, 'Quantity cannot be empty.');
  }
}, true /* capture — runs before CartItems.onChange */);

/* Block form submission when Enter is pressed on an invalid/empty field */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;
  var input = e.target;
  if (!input.classList || !input.classList.contains('quantity__input')) return;
  if (!input.closest('#CartDrawer')) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  if (_cdQtyIsInvalid(input)) {
    _cdQtyRestore(input);
    _cdQtyShowError(input, 'Quantity cannot be empty.');
    return;
  }

  /* Valid value — trigger the debounced cart-update handler */
  input.dispatchEvent(new Event('change', { bubbles: true }));
}, true);

/* ── Shipping Protection toggle ───────────────────────────────────────────────
   • Auto-adds the protection product when the cart drawer opens (if the user
     hasn't explicitly opted out in this session).
   • Toggle ON  → add variant to cart, clear opt-out flag.
   • Toggle OFF → remove variant from cart, set opt-out flag in sessionStorage.
*/
(function () {
  'use strict';

  var SP_OPTED_OUT_KEY = 'sp_opted_out';
  var SP_SECTIONS = 'el-cart-drawer,el-cart-icon-bubble';

  function getShippingProtectionConfig() {
    var el = document.getElementById('el-shipping-protection-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function getSpVariantId() {
    var config = getShippingProtectionConfig();
    if (config && config.variantId) return String(config.variantId);
    var cb = getSpCheckbox();
    return cb && cb.dataset.variantId ? String(cb.dataset.variantId) : null;
  }

  function isShippingProtectionItem(item, config) {
    if (!item || !config) return false;
    if (config.variantId && String(item.variant_id) === String(config.variantId)) return true;
    if (config.productId && String(item.product_id) === String(config.productId)) return true;
    return false;
  }

  function isHiddenDrawerItem(item, config) {
    if (isShippingProtectionItem(item, config)) return true;
    var props = item.properties || {};
    if (String(props._bundle_free) === '1') return true;
    return false;
  }

  function hasVisibleDrawerItems(cart) {
    var config = getShippingProtectionConfig();
    return (cart.items || []).some(function (item) {
      return !isHiddenDrawerItem(item, config);
    });
  }

  function shouldRemoveOrphanShippingProtection(cart) {
    var config = getShippingProtectionConfig();
    if (!config || !config.variantId || !cart || !cart.items || !cart.items.length) return false;

    var hasShippingProtection = cart.items.some(function (item) {
      return isShippingProtectionItem(item, config);
    });

    return hasShippingProtection && !hasVisibleDrawerItems(cart);
  }

  function getSpCheckbox() {
    return document.querySelector('#CartDrawer .cd-sp__checkbox');
  }

  /* ── Loading overlay (reuses existing .cd-cleanup-overlay CSS) ── */
  function getOrCreateOverlay() {
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!inner) return null;
    var existing = inner.querySelector('.cd-cleanup-overlay');
    if (existing) return existing;
    var el = document.createElement('div');
    el.className = 'cd-cleanup-overlay';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<svg class="cd-cleanup-overlay__spinner" viewBox="25 25 50 50">' +
      '<circle class="cd-cleanup-overlay__path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/>' +
      '</svg>';
    inner.appendChild(el);
    return el;
  }

  function showLoading() {
    var el = getOrCreateOverlay();
    if (el) el.classList.add('is-visible');
  }

  function hideLoading() {
    var el = document.querySelector('#CartDrawer .drawer__inner .cd-cleanup-overlay');
    if (el) el.classList.remove('is-visible');
  }

  function safeFetch(url, opts) {
    return fetch(url, opts)
      .then(function (r) {
        if (r.status === 429) { window.location.reload(); return Promise.reject('429'); }
        return r.json();
      })
      .catch(function (err) {
        if (err !== '429') console.error('[ShippingProtection]', err);
        return null;
      });
  }

  function refreshCartUI() {
    var path = window.location.pathname;
    var url = path + '?sections=el-cart-drawer,el-cart-icon-bubble&sections_url=' + encodeURIComponent(path);
    return safeFetch(url, {}).then(function (data) {
      if (!data) { hideLoading(); return; }

      var drawerHtml = data['el-cart-drawer'];
      if (drawerHtml) {
        var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        var newCartDrawer = doc.querySelector('#CartDrawer');
        var currCartDrawer = document.querySelector('#CartDrawer');
        if (newCartDrawer && currCartDrawer) {
          currCartDrawer.innerHTML = newCartDrawer.innerHTML;
          /* Re-attach overlay close listener */
          var overlay = currCartDrawer.querySelector('#CartDrawer-Overlay');
          var drawerEl = document.querySelector('cart-drawer');
          if (overlay && drawerEl) overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
          /* Re-init upsell carousel */
          if (typeof window.initCartUpsellCarousel === 'function') window.initCartUpsellCarousel(drawerEl);
        }
        var newDrawerEl = doc.querySelector('cart-drawer');
        var currDrawerEl = document.querySelector('cart-drawer');
        if (newDrawerEl && currDrawerEl) {
          currDrawerEl.classList.toggle('is-empty', newDrawerEl.classList.contains('is-empty'));
        }
      }

      var bubbleHtml = data['el-cart-icon-bubble'];
      if (bubbleHtml) {
        var doc2 = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        var newBubble = doc2.querySelector('.shopify-section');
        var currBubble = document.getElementById('el-cart-icon-bubble');
        if (newBubble && currBubble) currBubble.innerHTML = newBubble.innerHTML;
      }

      /* Hide after DOM is fully replaced (overlay element is gone from DOM now) */
      hideLoading();
    });
  }

  window.removeOrphanShippingProtection = async function (cartState) {
    if (!shouldRemoveOrphanShippingProtection(cartState)) return null;

    var variantId = getSpVariantId();
    if (!variantId) return null;

    var data = await safeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
        sections: SP_SECTIONS,
        sections_url: window.location.pathname,
      }),
    });

    if (!data) return null;

    if (data.sections && typeof window.applyFreeGiftCartSections === 'function') {
      window.applyFreeGiftCartSections(data);
    } else {
      await refreshCartUI();
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // drawerRendered: this handler already replaced the drawer markup above,
      // so cart-drawer-items can skip its redundant section refetch.
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection', cartData: data, drawerRendered: true });
    }

    return data;
  };

  function spAdd(variantId, silent) {
    // silent: skip the full-drawer dimming overlay (used for the auto-add that
    // fires on drawer open, so it doesn't blank a drawer that already has items).
    if (!silent) showLoading();
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    return safeFetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (data) {
      if (!data) { hideLoading(); return; }
      return refreshCartUI().then(function () {
        // Shipping protection changes the qualifying subtotal, which can push the
        // cart across the free-gift threshold — re-run the gift reconciliation.
        if (typeof window.syncFreeGiftFromDrawer === 'function') {
          return window.syncFreeGiftFromDrawer();
        }
      });
    });
  }

  function spRemove(variantId) {
    showLoading();
    return safeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    }).then(function (data) {
      if (!data) { hideLoading(); return; }
      return refreshCartUI().then(function () {
        // Shipping protection changes the qualifying subtotal, which can push the
        // cart across the free-gift threshold — re-run the gift reconciliation.
        if (typeof window.syncFreeGiftFromDrawer === 'function') {
          return window.syncFreeGiftFromDrawer();
        }
      });
    });
  }

  function tryAutoAdd() {
    if (sessionStorage.getItem(SP_OPTED_OUT_KEY) === '1') return;
    var cb = getSpCheckbox();
    if (!cb) return;
    if (cb.dataset.inCart === 'true') return;
    var variantId = cb.dataset.variantId;
    if (!variantId) return;
    spAdd(variantId, true);
  }

  function scheduleOrphanShippingProtectionCleanup(cartState) {
    if (!cartState) return;
    window.removeOrphanShippingProtection(cartState).catch(function (err) {
      console.error('[ShippingProtection]', err);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'shipping-protection') return;

      var cartState = event && event.cartData;
      if (cartState) {
        scheduleOrphanShippingProtectionCleanup(cartState);
        return;
      }

      fetch('/cart.js')
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(scheduleOrphanShippingProtectionCleanup)
        .catch(function (err) {
          console.error('[ShippingProtection]', err);
        });
    });
  });

  /* Toggle change — event delegation so it survives innerHTML replacements */
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.classList || !cb.classList.contains('cd-sp__checkbox')) return;
    var variantId = cb.dataset.variantId;
    if (!variantId) return;
    cb.disabled = true;
    if (cb.checked) {
      sessionStorage.removeItem(SP_OPTED_OUT_KEY);
      spAdd(variantId);
    } else {
      sessionStorage.setItem(SP_OPTED_OUT_KEY, '1');
      spRemove(variantId);
    }
  });

  /* Auto-add when the drawer opens */
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class' && cartDrawerEl.classList.contains('active')) {
          setTimeout(tryAutoAdd, 200);
          break;
        }
      }
    }).observe(cartDrawerEl, { attributes: true });
  }
})();